import { NoticeBannerPlacement, type NoticePublicRecord } from '@navio/nsdk';

/** Content stays a card. Top is the full-width strip. */
export const splitNoticesByPlacement = <T extends Pick<NoticePublicRecord, 'bannerPlacement'>>(
  notices: readonly T[]
) => ({
  content: notices.filter((notice) => notice.bannerPlacement !== NoticeBannerPlacement.TOP),
  top: notices.filter((notice) => notice.bannerPlacement === NoticeBannerPlacement.TOP)
});
